var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-input",on:{"click":function($event){return _vm.toggle()}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('i',{staticClass:"mdi mdi-arrow-down",class:{ 'down': _vm.asc === false, 'up': _vm.asc }})])}
var staticRenderFns = []

export { render, staticRenderFns }